export const setURLParams = (url, uuid) => {
  return url.replace('/:uuid', `/${uuid}`);
}

export const setURLParamsTwoUuid = (url, uuid, suuid) => {
  let newurl = url.replace('/:uuid', `/${uuid}`);
  return newurl.replace('/:suuid', `/${suuid}`);
}